import React from "react";

export const DNALoader = ({ label = "Analyzing ingredients..." }) => {
  const dots = Array.from({ length: 14 });
  return (
    <div data-testid="dna-loader" className="flex flex-col items-center justify-center gap-6 py-12">
      <div className="relative h-40 w-16 dna-spin">
        {dots.map((_, i) => {
          const t = i / dots.length;
          const y = t * 160;
          const left = 50 + 30 * Math.sin(t * Math.PI * 2.5);
          const right = 50 + 30 * Math.sin(t * Math.PI * 2.5 + Math.PI);
          return (
            <React.Fragment key={i}>
              <span
                className="absolute h-3 w-3 rounded-full"
                style={{
                  top: `${y}px`,
                  left: `${left}%`,
                  transform: "translate(-50%, -50%)",
                  background: "#A8FF3E",
                  boxShadow: "0 0 12px #A8FF3E",
                }}
              />
              <span
                className="absolute h-3 w-3 rounded-full"
                style={{
                  top: `${y}px`,
                  left: `${right}%`,
                  transform: "translate(-50%, -50%)",
                  background: "#00C853",
                  boxShadow: "0 0 12px #00C853",
                }}
              />
            </React.Fragment>
          );
        })}
      </div>
      <div className="font-mono text-xs tracking-[0.25em] uppercase text-[color:var(--text-2)]">
        {label}
      </div>
    </div>
  );
};

export default DNALoader;
